module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "intro-view"
  }, [_c('div', {
    staticClass: "intro-view-content"
  }, [_c('div', {
    staticClass: "intro-view-content-logo"
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("VUWE")]), _vm._v(" "), _c('h4', [_vm._v("WeUI for VueJS2.0")]), _vm._v(" "), _c('div', {
    staticClass: "intro-view-content-QR"
  }, [_c('img', {
    attrs: {
      "src": "static/img/QR.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Scan QR code to see demo")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-0ff78040!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/intro.vue
// module id = 220
// module chunks = 0